// Copy to clipboard functionality
document.addEventListener('DOMContentLoaded', () => {
  const copyButtons = document.querySelectorAll('[data-copy-button]')

  copyButtons.forEach(button => {
    button.addEventListener('click', async () => {
      const container = button.closest('[class*="font-mono"]')
      const copyable = container?.querySelector('[data-copyable]')

      if (!copyable) return

      const text = copyable.textContent?.trim()
      if (!text) return

      try {
        await navigator.clipboard.writeText(text)

        // Toggle icons
        const copyIcon = button.querySelector('.copy-icon')
        const checkIcon = button.querySelector('.check-icon')

        if (copyIcon && checkIcon) {
          copyIcon.classList.add('hidden')
          checkIcon.classList.remove('hidden')

          // Reset after 2 seconds
          setTimeout(() => {
            copyIcon.classList.remove('hidden')
            checkIcon.classList.add('hidden')
          }, 2000)
        }
      } catch (err) {
        console.error('Failed to copy text:', err)
      }
    })
  })
})
